import {
  Component,
  Injector,
  Input,
  OnDestroy,
  OnInit
} from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subject } from 'rxjs';

import { BaseControlValueAccessor, IIrisFormFieldControl } from '@sondermind/iris/form-helpers';

@Component({
  selector: 'iris-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: IrisCheckboxComponent,
    },
  ],
  standalone: false
})

export class IrisCheckboxComponent
  extends BaseControlValueAccessor
  implements OnInit, OnDestroy, IIrisFormFieldControl {
  destroyed$ = new Subject<void>();
  id: string = '';
  isFocused: boolean = false;
  isHovered: boolean = false;
  isHighlightCircleVisible: boolean = false;

  /* Used by the parent iris-form-field */
  subFormControl: boolean = false;

  @Input() indeterminate: boolean = false;

  constructor(injector: Injector) { super(injector) }

  ngOnInit(): void {
    // Append random 5 digit number
    this.id = `checkbox-${Math.random().toString().substring(2, 7)}`;

    this.updateShowHighlightCircle();
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  onBlur() {
    this.isFocused = false;
    this.updateShowHighlightCircle();
  }

  onFocus(): void {
    this.isFocused = true;
    this.updateShowHighlightCircle();
  }

  onHoverEnter(): void {
    this.isHovered = true;
    this.updateShowHighlightCircle();
  }

  onHoverLeave(): void {
    this.isHovered = false;
    this.updateShowHighlightCircle();
  }

  updateShowHighlightCircle(): void {
    this.isHighlightCircleVisible = !this.control.disabled && (this.isFocused || this.isHovered);
  }

  override get control(): FormControl {
    return this.formControl || (this.controlContainer?.control?.get(this.formControlName) as FormControl);
  }
}
